<template>
  <div class="search-result-snippet">
    <p
      v-for="(parts, i) in cleanedSnippets"
      :key="i"
      class="search-result-snippet-part"
    >
   
      <span v-if="i === 0"> &hellip; </span>
      <span
        v-for="(part, index) in parts"
        v-if="!part.isGap"
        :key="index"
        :class="[
          { 'has-text-weight-bold': part.isMatch },
          'search-result-snippet-part',
        ]"
      >
        <span v-if="viewMode != 'image'">{{ part.string }}</span>
        
        <SearchResultContext
          v-if="
            viewMode != 'text' &&
            part.isMatch &&
            flatten(searchResult.coords)[part.matchCount]
          "
          :items="flatten(searchResult.coords)"
          :cropped-rect="flatten(searchResult.coords)[part.matchCount].rect"
          :image="searchResult.image"
        />
        &nbsp;
      </span>

      <span v-else> &hellip; </span>

      <template v-if="i < cleanedSnippets.length"> &hellip; </template>
    </p>
  </div>
</template>

<style>
.search-result-snippet-part {
  display: inline;
}
</style>

<script>
import SearchResultContext from "@/components/SearchResultContext.vue";

import { createValidator } from "@/utils/validation.js";
import { createMapper } from "@/utils/mapping.js";

const validator = createValidator("search-form");
const mapper = createMapper("search-form");

export default {
  name: "SearchResultSnippet",
  props: {
    data: {
      type: Array,
      required: true,
    },
    searchResult: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      matchIndex: 0,
      viewMode: "combined",
    };
  },
  watch: {
    viewMode: {
      handler(value) {
        if (value === validator.getDefault("view")) {
          const { view, ...query } = mapper.fromURL(this.$route.query);

          this.$router.push({
            ...this.$route,
            query: mapper.toURL(query),
          });
        } else {
          const query = mapper.toURL({ view: value });

          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              ...query,
            },
          });
        }
      },
      immediate: false,
    },
    "$route.query": {
      handler: "updateView",
      // NOTE: should NOT run before children's watchers
      immediate: false,
    },
  },
  components: {
    SearchResultContext,
  },
  computed: {
    cleanedSnippets() {
      var that = this;
      var matchCount = 0;
      console.log('cleaned data', this.data)
      return this.data.map(function (parts) {
        return parts
          .map(function (part) {
            var obj = {
              isMatch: part.isMatch,
              string: !part.isMatch ? that.clean(part.string) : part.string,
              matchCount: part.isMatch ? matchCount++ : matchCount,
            };
            return obj;
          })
          .filter((part) => !!part.string);
      });
    },
  },
  methods: {
    flatten(arr) {
      let that = this
      return arr.reduce(function (flat, toFlatten) {
        return flat.concat(
          Array.isArray(toFlatten) ? that.flatten(toFlatten) : toFlatten
        );
      }, []);
    },
    clean(s) {
      const stack = [(t) => t.replace(/¬ /g, "")];
      let t = s;
      while (t && stack.length > 0) {
        const f = stack.shift();
        t = f(t);
      }
      return t.trim();
    },
    updateView(query, prevQuery = {}) {
      if (query["view"] != prevQuery["view"]) {
        this.viewMode = query["view"];
      }
    },
  },
};
</script>
